import merge from 'lodash/merge';

var module = (function($, otuApp) //shortcuts $=jQuery, w=window
{
    const jogInPlace = 1;
    const uprights = 2;
    const sitUps = 3;
    const pushUps = 4;
    const jumpingJacks = 5;
    const chickenSquates = 6;
    const other=99;

    const assignmentExercise=2;
    const challengeBeachExercise=3;

    const exerciseInfo = {
        [jogInPlace] : {
            name : "Jog In Place"
        },
        [uprights] : {
            name : "Uprights"
        },
        [sitUps] : {
            name : "Sit-Ups"
        },
        [pushUps] : {
            name : "Push-Ups"
        },
        [jumpingJacks] : {
            name : "Jumping Jacks"
        },
        [chickenSquates] : {
            name : "Chicken Squats"
        },
        [other] : {
            name : "Other"
        }
    }

    const assignmentInfo ={
        101 : {
            id:101,
            name:"OP_TRK_ASS1",
            type:assignmentExercise,
            exercise: {
                repeat:3,
                set: [
                    { 
                        duration : 202,
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:30, 
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:20,
                        exerciseId: chickenSquates
                    },
                    {
                        duration:3,
                        exerciseId:other
                    },
                    {
                        duration:40,
                        exerciseId: uprights
                    },            
                    {
                        duration:5,
                        exerciseId:other
                    },
                    
                    {
                        duration:15,
                        exerciseId: sitUps
                    },
                    {
                        duration:2,
                        exerciseId:other
                    },
                    {
                        duration:10, // it more like 15 seconds?
                        exerciseId: pushUps
                    },
                    {
                        duration:5,
                        exerciseId:other
                    },
                    { 
                        duration : 113,
                        exerciseId: other,
                        onlyOnIteration :  [3]
                    },
                ]
            }
        },
        1011 : {
            id:1011,
            name:"OP_TRK_ASS1_TEAM",
            type:assignmentExercise,
            exercise: {
                repeat:3,
                set: [
                    { 
                        duration : 10,
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:30, 
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:20,
                        exerciseId: chickenSquates
                    },
                    {
                        duration:3,
                        exerciseId:other
                    },
                    {
                        duration:40,
                        exerciseId: uprights
                    },            
                    {
                        duration:5,
                        exerciseId:other
                    },
                    
                    {
                        duration:15,
                        exerciseId: sitUps
                    },
                    {
                        duration:2,
                        exerciseId:other
                    },
                    {
                        duration:10, // it more like 15 seconds?
                        exerciseId: pushUps
                    },
                    {
                        duration:5,
                        exerciseId:other
                    },
                ]
            }
        },
        102 : {
            id:102,
            name:"OP_TRK_ASS2",
            type:assignmentExercise,
            exercise: {
                repeat:4,
                set: [
                    { 
                        duration : 40, // 0 :40
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:40, // 1:20
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:30, // 1:50
                        exerciseId: chickenSquates
                    },
                    {
                        duration:60, // 2:50
                        exerciseId: uprights
                    },            
                    {
                        duration:25, // 3:15
                        exerciseId: sitUps
                    },
                    {
                        duration: 3, // 3:18
                        exerciseId:other
                    },
                    {
                        duration:15, //  3:33
                        exerciseId: pushUps
                    }
                ]
            }
        },
        103 : {
            id:103,
            name:"OP_TRK_ASS3",
            type:assignmentExercise,
            exercise: {
                repeat:5,
                set: [
                    { 
                        duration : 48, // 0 :48
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:50, // 1:38
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:40, // 2:18
                        exerciseId: chickenSquates
                    },
                    {
                        duration:80, // 3:38
                        exerciseId: uprights
                    },            
                    {
                        duration:30, // 4:08
                        exerciseId: sitUps
                    },
                    {
                        duration: 4, // 4:12
                        exerciseId:other
                    },
                    {
                        duration:20, //  4:32
                        exerciseId: pushUps
                    }
                ]
            }
        },
        104 : {
            id:104,
            name:"OP_TRK_ASS4",
            type:assignmentExercise,
            exercise: {
                repeat:1,
                set: [
                    { 
                        duration : 40, // 0 :40
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:60, // 1:40
                        exerciseId: jogInPlace
                    },
                    {
                        duration: 5, // 1:45
                        exerciseId:other
                    },
                    {
                        duration:30, // 2:15
                        exerciseId: pushUps
                    },
                    {
                        duration: 3, // 2:18
                        exerciseId:other
                    },
                    {
                        duration:60, // 3:18
                        exerciseId: jogInPlace
                    },
                    {
                        duration:30, // 3:48
                        exerciseId: pushUps
                    },
                    {
                        duration:45, // 4:33
                        exerciseId: jogInPlace
                    },
                    {
                        duration: 2, // 4:35
                        exerciseId:other
                    },
                    {
                        duration:60, // 5:35
                        exerciseId: uprights
                    },
                    {
                        duration:60, // 6:35
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:45, // 7:20
                        exerciseId: chickenSquates
                    },
                    {
                        duration: 4, // 7:24
                        exerciseId:other
                    },
                    {
                        duration:60, // 8:24
                        exerciseId: jogInPlace
                    },
                    {
                        duration: 3, // 8:27
                        exerciseId:other
                    },
                    {
                        duration:30, // 8:57
                        exerciseId: sitUps
                    },
                    {
                        duration:60, // 9:57
                        exerciseId: jogInPlace
                    },
                    {
                        duration:1, // 9:58
                        exerciseId: other
                    },
                    {
                        duration:30, // 10:28
                        exerciseId: sitUps
                    },
                    {
                        duration:45, // 11:13
                        exerciseId: jogInPlace
                    },
                    {
                        duration:60, // 12:13
                        exerciseId: uprights
                    },
                    {
                        duration:2, // 12:15
                        exerciseId: other
                    },
                    {
                        duration:60, // 13:15
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:45, // 14:00
                        exerciseId: chickenSquates
                    },
                    {
                        duration:5, // 14:05
                        exerciseId: other
                    },
                    {
                        duration:60, // 15:05
                        exerciseId: jogInPlace
                    },
                    {
                        duration:2, // 15:07
                        exerciseId: other
                    },
                    {
                        duration:30, // 15:37
                        exerciseId: pushUps
                    },
                    {
                        duration:3, // 15:40
                        exerciseId: other
                    },
                    {
                        duration:60, // 16:40
                        exerciseId: jogInPlace
                    },
                    {
                        duration:30, // 17:10
                        exerciseId: sitUps
                    },
                    {
                        duration:80, // 18:30
                        exerciseId: uprights
                    },
                    {
                        duration:40, // 19:10
                        exerciseId: chickenSquates
                    },
                    {
                        duration:60, // 20:10
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:60, // 21:10
                        exerciseId: jogInPlace
                    }

                ]
            }
        },
        201 : {
            id:201,
            name:"OP_TRK_WAKEUP",
            type:challengeBeachExercise,
            exercise: {
                repeat:1,
                set: [
                    { 
                        duration : 10, // 0:10
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:35, // 0:45
                        exerciseId: uprights
                    },
                    {
                        duration:50, // 1:35
                        exerciseId: jogInPlace
                    },
                    {
                        duration:2, // 1:37
                        exerciseId: other
                    },
                    {
                        duration:25, // 2:02
                        exerciseId: chickenSquates
                    },
                    {
                        duration:43, // 2:45
                        exerciseId: jogInPlace
                    },
                    {
                        duration:35, // 3:20
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:2, // 3:22
                        exerciseId: other
                    },
                    {
                        duration:30, // 3:52
                        exerciseId: jogInPlace
                    },
                    {
                        duration:3, // 3:55
                        exerciseId: other
                    },
                    {
                        duration:15, // 4:10
                        exerciseId: uprights
                    },
                    {
                        duration:15, // 4:25
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:35, // 5:00
                        exerciseId: jogInPlace
                    },

                ]
            }
        },
        202 : {
            id:202,
            name:"OP_TRK_TESTTAKER",
            type:challengeBeachExercise,
            exercise: {
                repeat:1,
                set: [
                    { 
                        duration : 20, // 0:20
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:65, // 1:25
                        exerciseId: jogInPlace
                    },
                    {
                        duration:30, // 1:55
                        exerciseId: chickenSquates
                    },
                    {
                        duration:60, // 2:55
                        exerciseId: uprights
                    },
                    {
                        duration:60, // 3:55
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:60, // 4:55
                        exerciseId: jogInPlace
                    },
                    {
                        duration:30, // 5:25
                        exerciseId: chickenSquates
                    },
                    {
                        duration:70, // 6:35
                        exerciseId: jogInPlace
                    },
                    {
                        duration:30, // 7:05
                        exerciseId: chickenSquates
                    },
                    {
                        duration:60, // 8:05
                        exerciseId: uprights
                    },
                    {
                        duration:55, // 9:00
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:65, // 10:05
                        exerciseId: jogInPlace
                    },
                    {
                        duration:30, // 10:35
                        exerciseId: chickenSquates
                    },

                ]
            }
        },
        203 : {
            id:203,
            name:"OP_TRK_ENERGIZR",
            type:challengeBeachExercise,
            exercise: {
                repeat:1,
                set: [
                    { 
                        duration : 15, // 0:15
                        exerciseId: other,
                        onlyOnIteration :  [1]
                    },
                    {
                        duration:75, // 1:30
                        exerciseId: jogInPlace
                    },
                    {
                        duration:15, // 1:45
                        exerciseId: uprights
                    },
                    {
                        duration:15, // 2:00
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:25, // 2:25
                        exerciseId: jogInPlace
                    },
                    {
                        duration:4, // 2:29
                        exerciseId: other
                    },
                    {
                        duration:20, // 2:49
                        exerciseId: uprights
                    },
                    {
                        duration:35, // 3:24
                        exerciseId: jogInPlace
                    },
                    
                    {
                        duration:30, // 3:54
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:25, // 4:19
                        exerciseId: jogInPlace
                    },
                    {
                        duration:15, // 4:35
                        exerciseId: uprights
                    },
                    {
                        duration:15, // 4:50
                        exerciseId: jumpingJacks
                    },
                    {
                        duration:25, // 5:15
                        exerciseId: jogInPlace
                    },

                ]
            }
        }

    }
        
    // todo make these constants save a copy of there with the player object !

    var trackSaveInterval=15000;
    var trackBuffer={};
    var lastTrackSave = null;
    var lastUpdateCall =null;

    var _ = {
        onPlay : function () {
            console.log('Exercise Tracking - onPlay ');
            lastUpdateCall=new Date();

            // console.log(this);
        },
        onTimeUpdate : function ( data ) {
            _.trackExerciseTime({ player:this, currentTime:data.seconds });

        },
        onWaiting : function () {
            console.log('Exercise Tracking - Video Waiting');
            _.saveTrackedExerciseTimeBuffer({ player:this, pause:true});
        },
        onPause : function () {
            console.log('Exercise Tracking - Video Pause');
            _.saveTrackedExerciseTimeBuffer({ player:this, pause:true});
        },
        onSeeking : function () {
            console.log('Exercise Tracking - Video Seeking');
            _.pauseTrackExerciseTime({ player:this });
        },
        onEnded : function () {
            console.log('Exercise Tracking - Video ended');
            _.exerciseEnded( { player : this });
        },
        findCurrentExercise : function (Options={}) {
            var options = {
                player:null, 
                currentTime:null
            };
            $.extend(options,Options);

            let currentExercise =  options.player.myOptions.set.find(element => {
                return (options.currentTime >= element.start && options.currentTime < element.end);
            });

            return currentExercise;
        },
        setCurrentExercise : function(Options = {}) {
            var options = {
                player:null, // a vimeoPlayer object with and exercise video 
                exerciseId:null // the id of the exercise
            };
            $.extend(options,Options);

            console.log('Exercise Tracking - Setting Exercise Set')

            options.player.myOptions.set=_.buildExerciseSet(options);
            options.player.myOptions.workout_id=options.exerciseId

            console.log(options.player.myOptions.set);

        },
        buildExerciseSet: function(Options={}) {
            var options = {
                player:null, // a vimeoPlayer object with and exercise video 
                exerciseId:null // the id of the exercise
            };
            $.extend(options,Options);

            var info=assignmentInfo[options.exerciseId];
            var set=[];
            var timeOffset=0;

            for(let i=1;i<=info.exercise.repeat;i++) {
                for (let j=0;j<info.exercise.set.length;j++) {
                    let exercise = info.exercise.set[j]

                    if (typeof exercise.onlyOnIteration==='undefined' || 
                        $.inArray( i, exercise.onlyOnIteration)!==-1) {

                        set.push({
                            id : exercise.exerciseId,
                            start : timeOffset,
                            end : timeOffset + exercise.duration
                        });
                        timeOffset += exercise.duration;
                    }
                }
            }

            return set;

        },
        timeToSeconds : function (timeStr) {
            let segments = timeStr.split(':');
            return (segments[0]*60) + segments[1];
        },
        trackExerciseTime: function (Options={}) {
            var options = {
                player:null, 
                currentTime:null
            };
            $.extend(options,Options);

            if (otuApp.appUser.guest) return;
    
            var now =new Date();
    
            if (lastUpdateCall===null) {
              console.log('Exercise Tracking: Resuming Exercise Tracking');
              lastUpdateCall=now;
              return true;
            }
    
            var timeSinceLastCall = now - lastUpdateCall;
            lastUpdateCall=now;
    
            let playingWorkout=_.findCurrentExercise(options);
    
            if (typeof playingWorkout !== 'undefined') {
              
              _.saveTrackedExerciseTime({
                workout:playingWorkout,
                time:timeSinceLastCall,
                player:options.player,
                currentTime:options.currentTime
              })
    
            } 
    
            if (options.pause) _.pauseTrackExerciseTime();
    
    
          },
          saveTrackedExerciseTime : function (options = {}) {

            if (otuApp.appUser.guest) return;
    
            let now =new Date();
            if (lastTrackSave==null) lastTrackSave=new Date();
    
            // console.log('Tracking ' + options.workout.id + ' adding ' + options.time);
    
            if (typeof trackBuffer[options.workout.id] === 'undefined') {
              trackBuffer[options.workout.id] = { id : options.workout.id, time: 0 };
              console.log('Exercise Tracking - Starting to track exercise ' + exerciseInfo[options.workout.id].name + ' at ' + options.currentTime)
            }
    
            trackBuffer[options.workout.id].time=options.time + trackBuffer[options.workout.id].time;
            
            if ((now - lastTrackSave) > trackSaveInterval) {
              // we save to the server at the set interval
              _.saveTrackedExerciseTimeBuffer(options);
    
            }
          },
          saveTrackedExerciseTimeBuffer: function (options={}) {

            if (otuApp.appUser.guest) return;
            
            if (options.pause) _.pauseTrackExerciseTime();
    
            if (Object.keys(trackBuffer).length) {
                //console.log('Exercise Tracking - Saving Exercise Tracking Buffer');

                let now = new Date();

                var _buffer = Object.assign({},trackBuffer);

                trackBuffer={};

                lastTrackSave=now;

                let data = {
                    title: assignmentInfo[options.player.myOptions.exerciseId].name,
                    trackedExercises : _buffer,
                    type :  assignmentInfo[options.player.myOptions.exerciseId].type
                }

                
                otuApp.triggerAjaxPost(
                    otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=exerciseTracking.track', 
                    data, 
                    {
                        responseType:'json',
                        debug:false,
                        noSysInteraction:true,
                        callback : (response) => {
                            //console.log("Workout Generator - data tracked: ", response);
                        }
                    }
                );

            }
          },
          pauseTrackExerciseTime: function () {
            console.log('Exercise Tracking: Pausing Exercise Tracking');
            lastUpdateCall=null;
          },
          exerciseEnded : function (Options={}) {
            var options = {
                player:null            };
            $.extend(options,Options);
            var data = {};
            if (this.player !== null) {
                data = {
                    id : assignmentInfo[options.player.myOptions.exerciseId].id,
                    title : assignmentInfo[options.player.myOptions.exerciseId].name,
                    type : assignmentInfo[options.player.myOptions.exerciseId].type
                }
            }

            otuApp.triggerAjaxPost(
                otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=exerciseTracking.exerciseFinished', 
                data, 
                {
                    responseType:'json',
                    debug:false,
                    noSysInteraction:true,
                    callback : (response) => {
                        console.log("Exericse Tracking - onEnded success: ", response);

                        // check if we have a callback to call, usually the finished script of the video page
                        if (typeof options.player.myOptions.onEnded === 'function') {
                            options.player.myOptions.onEnded();
                        }

                    }
                }
            );
          }
    }

    // public interface
    otuApp.exerciseTracking= {
    track: function(Options = {}) {
        var options = {
            player:null, // a vimeoPlayer object with and exercise video 
            exerciseId:null // the id of the exercise
        };
        $.extend(options,Options);

        console.log('Exercise Tracking - Tracking exercise ' + options.exerciseId);
        
        let player=options.player;

        // store our options with the player
        player.myOptions=options;

        _.setCurrentExercise(options);

        player.on("play", _.onPlay);
        player.on("timeupdate", _.onTimeUpdate);
        player.on("waiting", _.onWaiting);
        player.on("pause", _.onPause);
        player.on("seeking", _.onSeeking);
        player.on("ended",_.onEnded);

        }
    }

})(jQuery, window.otuApp, undefined);
